<template>
  <div>
    <CRow class="content-fade-in">
      <CCol md="12">
        <CCard>
          <CCardBody>
            <CForm class="form-basic">
              <CRow>
                <CCol sm="6" md="6" xl="6">
                  <BaseInput :options="codeInput.options" :data="codeInput.data"/>
                </CCol>
                <CCol sm="6" md="6" xl="6">
                  <BaseInput :options="titleInput.options" :data="titleInput.data"/>
                </CCol>

                <CCol sm="12" md="12" xl="12">
                  <div class="form-input-wrapper">
                    <label class="form-label" for="uploadFile">Chọn tệp tin<span class='required'> *</span></label>
                    <div class="custom-file"
                         :class="selectedFiles.data.validator.isValid == false ? 'input-valid-error' : ''">
                      <input type="file" class="custom-file-input" id="uploadFile" ref="file"
                             accept=".xls, .xlsx" @change="selectFile($event)">
                      <label class="custom-file-label" for="uploadFile">{{ fileName }}
                        <i v-if="selectedFiles.data.loading" class="fa fa-spinner fa-spin"
                           style="position: absolute; right: 100px;font-size: 20px;top: 8px;"></i>
                      </label>
                    </div>
                    <div class="valid-error"
                         v-show="!(selectedFiles.data.validator ? selectedFiles.data.validator.isValid : true)">
                      {{ selectedFiles.data.validator ? selectedFiles.data.validator.errorMessage : "" }}
                    </div>
                  </div>
                </CCol>
                <CCol sm="12" md="12" xl="12">
                  <BaseTextArea :options="descriptionInput.options" :data="descriptionInput.data"
                                v-model="descriptionInput.data.model"/>
                </CCol>
              </CRow>
              <div slot="footer" class="mt-4">
                <CButton
                  color="primary"
                  class="btn-action-primary mr-2"
                  @click="submitData()">
                  <i class="fa fa-send"></i> Gửi
                </CButton>
                <CButton
                  color="secondary"
                  class="btn-action-primary mr-2"
                  @click="resetData()"><i class="fa fa-eraser"></i> Làm mới
                </CButton>
              </div>
              <BaseLoading :loading="loading.value"></BaseLoading>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import BaseSelect from "../base/BaseSelect2";
import BaseInput from "../base/BaseInput";
import BaseLoading from "../base/BaseFormLoading";
import BaseTextArea from "../base/BaseTextArea.vue";

export default {
  name: "ReportSendToTW",
  components: {BaseSelect, BaseInput, BaseLoading, BaseTextArea},
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Errors"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data: function () {
    let that = this;
    return {
      loading: {value: false},
      fileName: 'Chọn tệp',
      titleInput: {
        options: {
          label: "Tiêu đề báo cáo <span class='required'>*</span>",
          placeholder: "Tiêu đề báo cáo",
          maxlength: 200
        },
        data: {
          name: "title",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.titleInput.data.model;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Tiêu đề báo cáo không được để trống";
              } else {
                this.isValid = true;
              }
              return this.isValid;
            }
          }
        }
      },
      codeInput: {
        options: {
          label: "Mã báo cáo <span class='required'>*</span>",
          placeholder: "Mã báo cáo",
          maxlength: 200
        },
        data: {
          name: "code",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.codeInput.data.model;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Mã báo cáo không được để trống";
              } else {
                this.isValid = true;
              }
              return this.isValid;
            }
          }
        }
      },
      descriptionInput: {
        options: {
          label: "Mô tả báo cáo",
          placeholder: "Mô tả báo cáo",
          maxlength: 2000,
          rows: 5
        },
        data: {
          name: "description",
          model: "",
          updateCallback: function () {
            that.submitData();
          }
        }
      },
      selectedFiles: {
        data: {
          loading: false,
          name: "file",
          model: {
            fileName: '',
            content: '',
            size: '',
            type: ''
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              this.isValid = that.validateFile();
              return this.isValid;
            }
          }
        }
      },
    }
  },
  methods: {
    submitData: function () {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/report/send-to-tw",
        dataRef: function () {
          return that.$data;
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({
              message: "Gửi báo cáo thành công"
            });
            that.resetData();
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    selectFile() {
      let that = this;
      let reader = new FileReader();
      let file = this.$refs.file;
      if (file && file.files[0]) {
        file = file.files[0];
        this.selectedFiles.data.loading = true;
        reader.readAsDataURL(file);

        reader.onload = function () {
          that.fileName = file.name;
          that.validateFile(file.type, file.size);
          that.selectedFiles.data.model.size = file.size;
          that.selectedFiles.data.model.fileName = file.name;
          that.selectedFiles.data.model.content = file.name;
          that.selectedFiles.data.model.type = file.type;
          that.selectedFiles.data.model.content = reader.result.split(',')[1];
        }
        reader.onloadend = function () {
          that.selectedFiles.data.loading = false;
        }
      } else {
        that.fileName = "Chọn tệp";
        that.selectedFiles.data.model.size = "";
        that.selectedFiles.data.model.fileName = "";
        that.selectedFiles.data.model.type = "";
        that.validateFile();
      }
    },
    validateFile(type, size) {
      let isValid = true;
      if ((type && type != undefined) && (size && size != undefined)) {
        isValid = this.validateFileType(type, size);
      } else {
        if (this.selectedFiles.data.model.type && this.selectedFiles.data.model.size) {
          isValid = this.validateFileType(this.selectedFiles.data.model.type, this.selectedFiles.data.model.size);
        } else {
          if (this.selectedFiles.data.model.fileName === '') {
            this.selectedFiles.data.validator.isValid = false;
            this.selectedFiles.data.validator.errorMessage = "Nội dung bản tin không để trống";
            isValid = false;
          }
        }
      }
      return isValid;
    },
    validateFileType(type, size) {
      let isValid = true;
      // if (size > FILE_MAX_SIZE && IS_CHECK_MAX_SIZE_UPLOAD) {
      //   this.dataSave.selectedFiles.data.validator.isValid = false;
      //   this.dataSave.selectedFiles.data.validator.errorMessage = "Tệp tin không được quá 150MB";
      //   isValid = false;
      // } else
      if (type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || type === "application/vnd.ms-excel") {
        this.selectedFiles.data.validator.isValid = true;
        this.selectedFiles.data.validator.errorMessage = "";
      } else {
        this.selectedFiles.data.validator.isValid = false;
        this.selectedFiles.data.validator.errorMessage = "Sai định dạng tệp tin";
        isValid = false;
      }
      return isValid;
    },
    resetData() {
      let that = this;
      that.$helper.setupDataResponse(that.$data, {});
      that.fileName = 'Chọn tệp';
      that.codeInput.data.model = '';
      that.titleInput.data.model = '';
      that.selectedFiles.data.model = {
        fileName: '',
        content: '',
        size: '',
        type: ''
      }
    }
  },
  computed: {},
  created() {
  },
  mounted() {
  },
  watch: {}
};
</script>
